<div class="header" color="bgt-primary">
  <h1 routerLink="/" class="header__title"><span>bgt</span>viewer</h1>

  <app-spin></app-spin>

  <div class="header__buttons">
    @if (!kaartViewActive()) {
      <button routerLink="/" mat-button>
        <mat-icon>public</mat-icon>Kaart
      </button>
    }

    @if (kaartViewActive()) {
      <button class="download" (click)="openDownloadDialog()" mat-button>
        <mat-icon>file_download</mat-icon>Downloaden
      </button>
    }
    @if ((authenticated$ | async) === false) {
      <button class="login" routerLink="/registratie/login" mat-button>
        <mat-icon>person</mat-icon>Inloggen
      </button>
    }
    @if ((authenticated$ | async) === false) {
      <button class="login" routerLink="/registratie/registreren" mat-button>
        <mat-icon>person_add</mat-icon>Registreren
      </button>
    }
    @if ((authenticated$ | async) === true) {
      <button class="login" routerLink="/app/account" mat-button
        matTooltip="Accountgegevens">
        <mat-icon>person_outline</mat-icon>{{ userName$ | async }} ({{ credits$ | async }})
      </button>
    }

    <div class="header__menu">
      <button mat-button [matMenuTriggerFor]="menu">
        <mat-icon>menu</mat-icon>Menu
      </button>
      <mat-menu #menu="matMenu">
        @if ((authenticated$ | async) === false) {
          <button class="login" routerLink="/registratie/login" mat-menu-item>
            <span>Inloggen</span>
          </button>
        }
        @if ((authenticated$ | async) === true) {
          <button class="login" routerLink="/app/account" mat-menu-item>
            <span> {{ userName$ | async }} ({{ credits$ | async }}) </span>
          </button>
        }
        @if ((authenticated$ | async) === false) {
          <button routerLink="/registratie/registreren" mat-menu-item>
            <span>Registeren</span>
          </button>
        }
        <a routerLink="./info/over"><button mat-menu-item>
          <span>Over BGTviewer</span>
        </button></a>
        @if (kaartViewActive()) {
          <button class="download" (click)="openDownloadDialog()" mat-menu-item>
            <span>Downloaden</span>
          </button>
        }

        <button routerLink="/info/over-de-bgt" mat-menu-item>
          <span>Wat is de BGT?</span>
        </button>


        <button routerLink="/info/bgt-wms-wfs" mat-menu-item>
          <span>BGT WMS/WFS</span>
        </button>

        <button routerLink="/app/tarieven" mat-menu-item>
          <span>Tarieven</span>
        </button>
        <a routerLink="./info/faq/"><button mat-menu-item>
          <span>Veelgestelde vragen</span>
        </button></a>
        <button routerLink="/colofon" mat-menu-item>
          <span>Colofon</span>
        </button>
        <button onClick="window.open('https://geogap.nl/PrivacyPolicyGeogap.pdf');" mat-menu-item>
          <span>Privacybeleid</span>
        </button>

        @if ((user$ | async)?.admin === true) {
          <button routerLink="/admin" mat-menu-item>
            <span>Admin</span>
          </button>
        }
        @if ((authenticated$ | async) === true) {
          <button (click)="openLogoutDialog()" mat-menu-item>
            <span>Uitloggen</span>
          </button>
        }
      </mat-menu>
    </div>
  </div>
</div>